import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getSectionTheme, SECTIONS } from 'theme/section-colors';
import usePlatform from '../../lib/hooks/usePlatform';

export const getColorBasedOnRoute = (pathname, isWebinarPlus = false) => {
    const path = pathname.replace(/^#?\/|\/$/, '');


    if (isWebinarPlus) {
        return getSectionTheme(SECTIONS.WP_DEFAULT);
    }

    if (
        path === 'login' ||
        path === 'sso-login' ||
        path === 'member-login' ||
        path === '3sqx5zr5lsvy' ||
        path === 'email-login' ||
        path === 'social-login' ||
        path === 'social-register' ||
        path === 'set-password' ||
        path === 'forgot-password' ||
        path === 'verify-account' ||
        path === 'change-password' ||
        path === 'orglogin' ||
        path === 'onboarding'
    ) {
        return getSectionTheme(isWebinarPlus ? SECTIONS.WP_AUTH : SECTIONS.AUTH);
    }

    if (
        path === 'events' ||
        path === 'events/ongoing' ||
        path === 'events/upcoming' ||
        path === 'events/ended' ||
        path === 'events/copying' ||
        path.startsWith('events/create/') ||
        path.match(/^events\/[^\/]+\/[^\/]+\/edit\//)
    ) {
        return getSectionTheme(SECTIONS.EVENTS);
    }

    if (
        path === 'account' ||
        path.startsWith('account/profile') ||
        path.startsWith('account/password') ||
        path.startsWith('account/sso')
    ) {
        return getSectionTheme(SECTIONS.ACCOUNT);
    }

    if (
        path === 'contacts' ||
        path.match(/^contacts\/[^\/]+\/profile-details/)
    ) {
        return getSectionTheme(SECTIONS.PEOPLE);
    }

    if (path === 'billing' || path === 'plans') {
        return getSectionTheme(SECTIONS.PAYOUT);
    }

    if (path === 'payout' || path === 'verify_stripe') {
        return getSectionTheme(SECTIONS.PAYOUT);
    }

    if (path === 'team' || path === 'team/role') {
        return getSectionTheme(SECTIONS.TEAM);
    }

    if (
        path === 'integrations' ||
        path.match(/^integration\/[^\/]+$/) ||
        path.match(/^integration\/[^\/]+\/setup/)
    ) {
        return getSectionTheme(SECTIONS.INTEGRATIONS);
    }

    if (
        path === 'analytics' ||
        path === 'analytics/overview-analytics' ||
        path === 'analytics/revenue-analytics' ||
        path === 'analytics/top-analytics' ||
        path === 'analytics/engagement-analytics'
    ) {
        return getSectionTheme(SECTIONS.ANALYTICS);
    }

    if (
        path === 'data-mapping' ||
        path.match(/^data-mapping\/[^\/]+$/) ||
        path.match(/^data-mapping\/[^\/]+\/status/) ||
        path.match(/^data-mapping\/[^\/]+\/[^\/]+$/)
    ) {
        return getSectionTheme(SECTIONS.DATA_MAPPING);
    }
    const eventRouteMatch = path.match(/^event\/[^\/]+\/[^\/]+(?:\/(.*))?$/);
    if (eventRouteMatch?.length > 0) {
        const subRoute = eventRouteMatch[1];


        if (!subRoute || subRoute === '') {
            return getSectionTheme(SECTIONS.OVERVIEW);
        }

        if (subRoute === 'registration-flow') {
            return getSectionTheme(SECTIONS.LANDING);
        }

        if (
            subRoute.startsWith('registration/landing-page') ||
            subRoute.startsWith('registration/setup-form') ||
            subRoute === 'registration/landing-page/choose-template' ||
            subRoute === 'registration/landing-page/choose-dlp-template'
        ) {
            return getSectionTheme(SECTIONS.LANDING);
        }

        if (
            subRoute.startsWith('registration/ticket') ||
            subRoute.startsWith('registration/addTicket') ||
            subRoute.match(/^registration\/editTicket\//) ||
            subRoute.startsWith('registration/discount') ||
            subRoute.startsWith('registration/order') ||
            subRoute.startsWith('registration/utm')
        ) {
            return getSectionTheme(SECTIONS.TICKETS);
        }

        if (
            subRoute === 'sessions' ||
            subRoute.match(/^session\/[^\/]+/)
        ) {
            return getSectionTheme(SECTIONS.SESSIONS);
        }

        if (subRoute === 'people') {
            return getSectionTheme(SECTIONS.PEOPLE);
        }

        if (
            subRoute === 'virtual-booth' ||
            subRoute.match(/^virtual-detail\/[^\/]+/)
        ) {
            return getSectionTheme(SECTIONS.BOOTHS);
        }

        if (subRoute === 'meetings') {
            return getSectionTheme(SECTIONS.MEETINGS);
        }

        if (subRoute === 'rooms') {
            return getSectionTheme(SECTIONS.ROOMS);
        }

        if (subRoute === 'lounge') {
            return getSectionTheme(SECTIONS.LOUNGE);
        }

        if (
            subRoute === 'brand-your-events' ||
            subRoute === 'brand-spaces' ||
            subRoute.match(/^brand-spaces\/brand-details\//)
        ) {
            return getSectionTheme(SECTIONS.SETTINGS);
        }

        if (
            subRoute.startsWith('engagement/leaderboard') ||
            subRoute.startsWith('engagement/notification') ||
            subRoute.startsWith('engagement/activity-feed') ||
            subRoute.startsWith('engagement/lead-score') ||
            subRoute.startsWith('engagement/survey') ||
            subRoute.startsWith('engagement/contest') ||
            subRoute.startsWith('engagement/quiz')
        ) {
            return getSectionTheme(SECTIONS.ENGAGEMENT);
        }

        if (subRoute === 'email-campaign') {
            return getSectionTheme(SECTIONS.EMAILS);
        }

        if (subRoute.startsWith('email-builder')) {
            return getSectionTheme(SECTIONS.EMAILS);
        }

        if (subRoute.startsWith('analytics')) {
            return getSectionTheme(SECTIONS.ANALYTICS);
        }

        if (subRoute.startsWith('settings')) {
            return getSectionTheme(SECTIONS.SETTINGS);
        }

        if (subRoute.startsWith('integrations')) {
            if (subRoute.startsWith('integrations/embed-apps')) {
                return getSectionTheme(SECTIONS.SETTINGS);
            }
            return getSectionTheme(SECTIONS.INTEGRATIONS);
        }

        if (subRoute === 'file-logs') {
            return getSectionTheme(SECTIONS.SETTINGS);
        }

        if (subRoute === 'recording') {
            return getSectionTheme(SECTIONS.SETTINGS);
        }
    }

    return getSectionTheme(SECTIONS.DEFAULT);
};



const SectionColorsSetter = () => {
    // ** Hooks
    const { location } = useHistory();
    const { isWebinarPlus } = usePlatform();


    useEffect(() => {
        if (location?.hash) {
            const pathname = location.hash.replace('#', '');
            const theme = getColorBasedOnRoute(pathname, isWebinarPlus);
            document.documentElement.style.setProperty('--vpro-menu-bg-color', theme.menuColor);
            document.documentElement.style.setProperty('--vpro-section-color', theme.sectionColor);
            document.documentElement.style.setProperty('--vpro-logo-primary', theme.logoPrimary);
            document.documentElement.style.setProperty('--vpro-logo-secondary', theme.logoSecondary);
            document.documentElement.style.setProperty('--vpro-sidebar-active', theme.sidebarActive);
            document.documentElement.style.setProperty('--vpro-sidebar-hover', theme.sidebarHover);
            document.documentElement.style.setProperty('--vpro-primary-main', theme.primaryColor.main);
            document.documentElement.style.setProperty('--vpro-primary-dark', theme.primaryColor.dark);
            document.documentElement.style.setProperty('--vpro-primary-darker', theme.primaryColor.darker);
            document.documentElement.style.setProperty('--vpro-primary-lighter', theme.primaryColor.lighter);
            document.documentElement.style.setProperty('--vpro-primary-light', theme.primaryColor.light);
            document.documentElement.style.setProperty('--vpro-primary-extraLight', theme.primaryColor.extraLight);
            document.documentElement.style.setProperty('--vpro-secondary-main', theme.secondaryColor.main);
            document.documentElement.style.setProperty('--vpro-secondary-dark', theme.secondaryColor.dark);
            document.documentElement.style.setProperty('--vpro-secondary-darker', theme.secondaryColor.darker);
            document.documentElement.style.setProperty('--vpro-secondary-lighter', theme.secondaryColor.lighter);
            document.documentElement.style.setProperty('--vpro-secondary-light', theme.secondaryColor.light);
            document.documentElement.style.setProperty('--vpro-secondary-extraLight', theme.secondaryColor.extraLight);
        }
    }, [location?.hash]);

    return null;
}

export default SectionColorsSetter